// Warning: this is just in case, or for quick comparison, not for general use,
// Please track and deprecate after GA/testing.
export const UrlPilots = {
  forcesubads: /(forcesubads=true|forcesubads=1)/,
  forceupsw: /(forceupsw=true|forceupsw=1)/,
  forceescgjapan: /(forceescgjapan=true|forceescgjapan=1)/,
  m365AdminTrackingId: /(s_cid=en-us-acq-onemsft-src_oom-sub_m365-flx_admincenter)/,
  m365EmailTrackingId: /(s_cid=en-us-acq-onemsft-src_oom-sub_m365-flx_m365onboarding)/,
  m365RmTrackingId: /(s_cid=en-us-acq-onemsft-src_oom-sub_m365)/,
  m365WebTrackingId: /(s_cid=en-us-acq-onemsft-src_oom-sub_m365-cam_skuchooser)/,
};

export const getDangerouslySetUrlPilot = key => (window.location.search.match(key));
